<template>
  <div class="flex flex-col gap-2">
    <div v-if="success" class="flex flex-col gap-2">
      <h2>{{ $t("spotdetail.delete_spot_success_title") }}</h2>
      <p>{{ $t("spotdetail.delete_spot_success_text") }}</p>
      <ButtonPrimary class="flex-grow" @click="goToSpots()">{{
        $t("general.continue")
      }}</ButtonPrimary>
    </div>
    <div v-else class="flex flex-col gap-2">
      <h2>{{ $t("spotdetail.delete_spot_title") }}</h2>
      <p>{{ $t("spotdetail.delete_spot_text") }}</p>
      <div class="flex gap-2">
        <ButtonPrimary class="flex-grow" @click="$emit('close')">{{
          $t("general.cancel")
        }}</ButtonPrimary
        ><ButtonSubmit
          :loading="loading"
          :error="error"
          @click="deleteSpot()"
          class="flex-grow"
          color="red"
          :title="$t('spotdetail.delete_spot_button_confirm_text')"
        ></ButtonSubmit>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

defineEmits(["close"]);
const { $api } = useNuxtApp()

const props = defineProps<{ spot: SpotDetail}>()
const router = useRouter();

const loading = ref<boolean>(false);
const error = ref<boolean>(false);
const success = ref<boolean>(false);

function goToSpots() {
  router.push("/spots");
}

function deleteSpot() {
  loading.value = true;
  error.value = false;

  $api("/spots/" + props.spot.id)
    .then(() => {
      success.value = true;
    })
    .catch(() => {
      error.value = false;
    })
    .finally(() => {
      loading.value = false;
    });

}
</script>
